// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3ye0d","buttons":"PendingPaymentAlert_buttons__uZA7J"};